import { createRoot } from "react-dom/client";
import { BackToTop } from "./back-to-top";

import "../../../packages/pvc-product/tokens.css";
import "../../../packages/pvc-product/components.css";
import "../../../packages/pvc-product/components-part-b.css";
import "../../../packages/pvc-product/components-price-state-patch.css";
import "../../../packages/pvc-product/pvc-product-page.css";
import "./storefront.css";
import "./pvc-storefront-ux.css";
import "./pvc-storefront-ux-final.css";
import "./checkout.css";
import "./checkout-account.css";
import "./customer-files.css";
import "./account.css";
import "./account-settings.css";
import "./account-security.css";
import "./account-files.css";
import "./account-billing.css";
import "./account-warm.css";
import "./product-designer/product-designer.css";
import "./homepage/homepage.css";
import "./product-pages/product-page.css";
import "./work-gallery/work-gallery.css";
import "./public-policy-page.css";
import "./contact-page.css";
import "./google-reviews/google-reviews.css";
import { App } from "./App";
import { applyRouteMetadata } from "./route-metadata";
import {
  ACCOUNT_SETTINGS_PATH,
  AccountSettingsPage,
} from "./account-settings-page";
import {
  AccountSecurityRouter,
  isAccountSecurityPath,
} from "./account-security-page";
import {
  ACCOUNT_FILES_PATH,
  AccountFilesPage,
} from "./account-files-page";
import {
  ACCOUNT_BILLING_PATH,
  AccountBillingPage,
} from "./account-billing-page";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Storefront root element is missing");

const path = window.location.pathname.replace(/\/+$/, "") || "/";
applyRouteMetadata(path);

const page = path === ACCOUNT_SETTINGS_PATH
  ? <AccountSettingsPage />
  : path === ACCOUNT_FILES_PATH
    ? <AccountFilesPage />
    : path === ACCOUNT_BILLING_PATH
      ? <AccountBillingPage />
      : isAccountSecurityPath(path)
        ? <AccountSecurityRouter />
        : <App />;

createRoot(rootElement).render(<>{page}<BackToTop /></>);
